import ShowMore from '../show-more/ShowMore';
import NewsCard from '../news-card/news-card';

export default new class Pagination {
  constructor() {
    this.pagination = '_show_more_rubric_page';
    this.buttonJournalList = '_show_more_journal_list';
    this.buttonTagPage = '_show_more_tag_page';
    this.buttonArticleAuthorPage = '_show_more_article_author_page';
    this.authorsPage = '_show_more_authors';
    this.wikiHomePage = '_show_more_wiki';
    this.articlesPreloaderSelector = '.articles__preloader';
    this.articlesContentList = '@.articles__content_list';
    this.articlesContentListPagination = '.articles__content_list_pagination';

    this.initBindings();
  }

  initBindings() {
    const onClick = () => {
      setTimeout(() => {
        ShowMore.initComponents(true);
      }, 100);
      ShowMore.initBindings();
      NewsCard.fixRubricWidth();
    };

    $(document).on('click', `.${this.pagination}`, (e) => {
      this.loadContent($(e.currentTarget), onClick);
    });

    $(document).on('click', `.${this.buttonTagPage}`, (e) => {
      this.getArticleListTagPage($(e.currentTarget), onClick);
    });

    $(document).on('click', `.${this.buttonArticleAuthorPage}`, (e) => {
      this.getAuthorArticleListPage($(e.currentTarget), onClick);
    });

    $(document).on('click', `.${this.buttonJournalList}`, (e) => {
      this.getJournalList($(e.currentTarget), onClick);
    });

    $(document).on('click', `.${this.authorsPage}`, (e) => {
      this.getAuthors($(e.currentTarget), onClick);
    });

    $(document).on('click', `.${this.wikiHomePage}`, (e) => {
      this.getWikiArticleList($(e.currentTarget), () => {
        NewsCard.fixRubricWidth();
      });
    });
  }

  /**
     * Get article list (rubric page)
     * @param $clickedButton
     * @param callback
     */
  loadContent($clickedButton, callback) {
    $.request('ArticleList::onAjaxRequest', {
      loading: this.articlesPreloaderSelector,
      update: {
        'project/desktop/ajax/article_list': this.articlesContentList,
        'project/desktop/ajax/article_list_pagination': this.articlesContentListPagination,
      },
      data: {
        page: $clickedButton.data('page'),
      },
      complete: () => {
        callback();
        // DISQUSWIDGETS.getCount({ reset: true }); // eslint-disable-line no-undef
      },
    });
  }

  /**
     * Get article list on tag page
     * @param $clickedButton
     * @param callback
     */
  getArticleListTagPage($clickedButton, callback) {
    $.request('ArticleList::onAjaxRequest', {
      loading: this.articlesPreloaderSelector,
      update: {
        'project/desktop/ajax/tag_article_list': this.articlesContentList,
        'project/desktop/ajax/tag_article_list_pagination': this.articlesContentListPagination,
      },
      data: {
        page: $clickedButton.data('page'),
      },
      complete: () => {
        callback();
        // DISQUSWIDGETS.getCount({ reset: true }); // eslint-disable-line no-undef
      },
    });
  }

  /**
     * Get article list on author page
     * @param $clickedButton
     * @param callback
     */
  getAuthorArticleListPage($clickedButton, callback) {
    $.request('ArticleList::onAjaxRequest', {
      loading: this.articlesPreloaderSelector,
      update: {
        'project/desktop/ajax/author_article_list': this.articlesContentList,
        'project/desktop/ajax/author_article_list_pagination': this.articlesContentListPagination,
      },
      data: {
        page: $clickedButton.data('page'),
      },
      complete: () => {
        callback();
        // DISQUSWIDGETS.getCount({ reset: true }); // eslint-disable-line no-undef
      },
    });
  }

  /**
     * Get journal list (journal home page)
     * @param $clickedButton
     * @param callback
     */
  getJournalList($clickedButton, callback) {
    const iPage = $clickedButton.attr('data-page');

    $.request('JournalList::onAjaxRequest', {
      loading: '.journal-home__pagination-preloader',
      data: {
        page: iPage,
      },
      update: {
        'project/desktop/ajax/journal_list': '@.journal-home-list-wrapper',
        'project/desktop/ajax/journal_list_pagination': '.journal-home-list-pagination-wrapper',
      },
      complete: () => {
        callback();
        // DISQUSWIDGETS.getCount({ reset: true }); // eslint-disable-line no-undef
      },
    });
  }

  /**
     * Get authors on authors-list
     * @param $clickedButton
     */
  getAuthors($clickedButton) {
    const iPage = $clickedButton.attr('data-page');

    $clickedButton.remove();
    $.request('AuthorList::onAjaxRequest', {
      loading: '.authors__preloader',
      data: {
        page: iPage,
      },
      update: {
        'project/common/authors/authors': '@.authors',
      },
      complete: () => {
        // DISQUSWIDGETS.getCount({ reset: true }); // eslint-disable-line no-undef
      },
    });
  }

  /**
     * Get wiki articles on wiki-home page
     * @param $clickedButton
     */
  getWikiArticleList($clickedButton) {
    const iPage = $clickedButton.attr('data-page');
    $clickedButton.remove();

    $.request('ArticleList::onAjaxRequest', {
      loading: this.articlesPreloaderSelector,
      data: {
        page: iPage,
      },
      update: {
        'project/common/wiki-home/wiki-home-useful-article': '@.wiki-home__content',
      },
      complete: () => {
        // DISQUSWIDGETS.getCount({ reset: true }); eslint-disable-line no-undef
        ShowMore.initComponents(true);
        ShowMore.initBindings(true);
      },
    });
  }
}();
